import SystemIcon from "./SystemIcon";

export default function Field({
  id,
  label,
  width,
  required = false,
  optional = false,
  hint,
  error,
  className = "",
  children,
}) {
  const widthClassName = width ? ` ds-field--${width}` : "";

  return (
    <div className={`ds-field${widthClassName}${error ? " ds-field--error" : ""}${className ? ` ${className}` : ""}`}>
      <div className="ds-field-label-row">
        <label className="ds-field-label" htmlFor={id}>
          {label}
          {required && <span className="ds-field-required" aria-label="필수">*</span>}
        </label>
        {optional && <span className="ds-field-optional">선택</span>}
      </div>
      {children}
      {hint && !error && (
        <span className="ds-field-hint">
          <SystemIcon name="information" size="xsmall" />
          <span>{hint}</span>
        </span>
      )}
      {error && (
        <span className="ds-field-error" role="alert">
          <SystemIcon name="error" size="xsmall" />
          <span>{error}</span>
        </span>
      )}
    </div>
  );
}
